import { render, staticRenderFns } from "./FocusTrap.vue?vue&type=template&id=601bca9b&"
import script from "./FocusTrap.vue?vue&type=script&lang=ts&"
export * from "./FocusTrap.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports